import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { parseISO, format } from 'date-fns';
import UpIcon from '@mui/icons-material/ArrowDropUp';
import DownIcon from '@mui/icons-material/ArrowDropDown';

import {
  blueGray,
  blueGrayLight,
  gray2,
  statusNeutral,
  statusTextNeutral,
} from 'utils/color-styles';
import Status from 'retired/Status';
import CalendarRoundedIcon from 'assets/icons/calendar-round.svg';
import WalletIcon from 'assets/icons/wallet.svg';

type Props = {
  onTogglePayrollRun: () => void;
  payrollRun: {
    startDate: string;
    endDate: string;
    stats: { donationCount?: number | null };
  };
  isUpcoming: boolean;
  isSelected: boolean;
  extra?: React.ReactNode;
};
export const PayrollScheduleHeader = ({
  onTogglePayrollRun,
  payrollRun,
  isUpcoming,
  isSelected,
  extra,
}: Props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginTop: 24,
      marginBottom: 12,
    }}
  >
    <Typography
      component="h3"
      onClick={onTogglePayrollRun}
      style={{
        fontSize: 18,
        fontWeight: 'bold',
        marginLeft: 16,
      }}
    >
      <IconButton aria-label="expand row" size="small">
        {isSelected ? <UpIcon /> : <DownIcon />}
      </IconButton>
      {format(parseISO(payrollRun.startDate), 'MMMM dd, yyyy')} –{' '}
      {format(parseISO(payrollRun.endDate), 'MMMM dd, yyyy')}
    </Typography>
    <Typography style={{ fontSize: 12, color: gray2, marginLeft: 8 }}>
      ({payrollRun.stats?.donationCount || 0} donation
      {payrollRun.stats?.donationCount === 1 ? '' : 's'})
    </Typography>
    <Status
      title={isUpcoming ? 'Upcoming' : 'Past'}
      color={isUpcoming ? statusNeutral : blueGrayLight}
      textColor={isUpcoming ? statusTextNeutral : blueGray}
      icon={isUpcoming ? CalendarRoundedIcon : WalletIcon}
      style={{ marginLeft: 8 }}
    />
    {extra}
  </div>
);
